import { Grid, IconButton, Paper, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export default function ViewLocation({ form }) {
    const { client_id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state;

    const properties = [
        { label: 'Location Name:', value: form?.name || '--' },
        { label: 'Map URL:', value: form?.map_url || '--' },
        { 
            label: 'TimeZone:', 
            value: form?.timezone 
              ? `${form.timezone} (UTC${moment.tz(form.timezone).format('Z')})` 
              : '--' 
        }
    ];

    const locationDetails = (
        <Paper 
                sx={{
                    wordWrap: 'break-word',
                    padding: {
                    xs: 0,
                    sm: 2, 
                    md: 2  
                    }
                }}
                >
            {properties.map((property, index) => (
                <div key={index}>
                    <Grid container item className='w3-padding'>
                        <Grid item xs={12} sm={6} md={6}>
                            <Typography sx={{ fontWeight: 'bold' }}>{property.label}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            {property.value}
                        </Grid>
                    </Grid>
                </div>
            ))}
        </Paper>
    )



    return (
        <Grid 
            container 
            sx={{
                padding: {
                xs: '12px 8px', 
                sm: '12px 8px', 
                md: '12px 24px' 
                }
            }}
        >
            <Grid container item xs={12}>
                <Grid item xs={5} justifyContent='flex-start'>
                    <IconButton
                        onClick={() => locationState?.status ? navigate(-1) : navigate(`/client/${client_id}/settings/locations`)}
                        color="inherit">
                        <ArrowBackIosIcon fontSize='small'/>
                    </IconButton>
                </Grid>
                <Grid item xs={7} justifyContent='flex-start'>
                    <h5 style={{ fontWeight: 'bold' }}>LOCATION DETAILS</h5>
                </Grid>
            </Grid>
            <Grid item xs={12}>
               {locationDetails}
            </Grid>
        </Grid>
    )
}